{
    "cryptotofiat": {
        "title": "Crypto to Fiat",
        "subtitle": "Select the token to create a valid wallet address to your FIAT account",
        "input": {
            "currency": "Select the token you want to convert",
            "chain": "Select the blockchain"
        }
    }
}